<template>
    <div class="grid grid-cols-1 gap-6">
        <div class="flex flex-col bg-white rounded-lg shadow">
            <div class="p-4">
                <div class="font-semibold">
                    {{ $t('Tickets') }}
                </div>
            </div>
            <div class="p-4">
                <loading :status="loading"/>
                <line-chart ref="chart" :chart-data="chartData" :height="500"></line-chart>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from "@/components/charts/line-chart";

export default {
    name: "opened-tickets",
    components: {LineChart},
    data() {
        return {
            loading: true,
            chartData: {
                labels: [
                    this.$t('Jan'), this.$t('Feb'), this.$t('Mar'), this.$t('Apr'), this.$t('May'), this.$t('Jun'), this.$t('Jul'), this.$t('Aug'), this.$t('Sept'), this.$t('Oct'), this.$t('Nov'), this.$t('Dec')
                ],
                datasets: [],
            },
            datasetTemplate: {
                label: '',
                borderColor: '',
                data: [],
                fill: false
            },
            alpha: '60'
        }
    },
    computed: {
        datasets() {
            return this.chartData.datasets;
        }
    },
    watch: {
        datasets() {
            this.$refs.chart.update();
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            const self = this;
            self.loading = true;
            axios.get('api/dashboard/stats/opened-tickets').then(function (response) {
                for (const year in response.data) {
                    const months = response.data[year];
                    let template = {...self.datasetTemplate};
                    template.label = year;
                    template.borderColor = self.randomColor();
                    template.data = months;
                    self.chartData.datasets.push(template);
                }
                self.loading = false;
            });
        },
        randomColor() {
            return '#' + [...Array(6)].map(() => Math.floor(Math.random() * 16).toString(16)).join('') + this.alpha;
        }
    },
}
</script>
